import styles from './all-contracts.module.scss';
import { Box, Container } from '@frontend-workspace/react-shared-lib';
import { Col, Row } from 'reactstrap';
import { useState } from 'react';
import { useGetRequestNewHook } from '../../requestUtils';
import { GetCurrentCompany } from '../../customer-context/customer-context';
import PageTitle from '../../page-title/page-title';

import AllContractsGrid from '../all-contracts-grid/all-contracts-grid';
import AllContractsGridSkeleton from '../all-contracts-grid/all-contracts-grid-skeleton';
import { IAllContracts } from '../../_models/all-contracts';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface AllContractsProps { salesforceBaseUrl?: string }

export function AllContracts(props: AllContractsProps) {
  const { t } = useTranslation();
  const [isGroup, setIsGroup] = useState<boolean>(false);
  const [onlyActive, setOnlyActive] = useState<boolean>(true);
  const currentCompany = GetCurrentCompany();
  const companyNumber = currentCompany ? currentCompany.number : "";

  const { data: allContracts, getData, isLoading }: { data: IAllContracts[], getData: () => void, isLoading: boolean } = useGetRequestNewHook(
    `companies/${companyNumber}/contracts/forGroup/${isGroup}/onlyActive/${onlyActive}`,
    [], [companyNumber, isGroup, onlyActive]);

  const handleIsGroupToggle = () => setIsGroup(!isGroup);
  const handleOnlyAciveToggle = () => setOnlyActive(!onlyActive);

  return (
    <Container
      className='container-fluid pt-4 px-0'
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component='div'
            className='pb-5'>
            <PageTitle title={t('app.contracts')} showNoCompanyMessage={!currentCompany} />
            {isLoading ?
              <AllContractsGridSkeleton /> :
              <AllContractsGrid
                salesforceBaseUrl={props.salesforceBaseUrl}
                allContracts={allContracts}
                isGroup={isGroup}
                getData={getData}
                onlyActive={onlyActive}
                onOnlyActiveChange={handleOnlyAciveToggle}
                onIsGroupChange={handleIsGroupToggle}
                isLoading={isLoading}
              />}
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export default AllContracts;